module.exports = __webpack_public_path__ + "img/eg.34cb0b1f.svg";